const PropTypes = require('prop-types');
var React = require('react');

export default function connectSensorStateComponent(Component) {
    return class extends React.Component {

        state = {
            sensor:null,
            connection:null
        };

        sensorSub = null;
        sensorPath = null;
        connectionPath = null;

        componentDidMount () {
            // TODO: This seems wrong
            // this.componentWillReceiveProps(this.props);
            if (this.props.sensorPath) {
                setSensorPath(this.props.sensorPath);
            }
        }

        // componentWillReceiveProps(nextProps) {
        //     const self = this;

        //     // storepath overrides datapath since we use this "trick" to write to config/DeviceLocation but read from
        //     // device.location
        //     if (nextProps.sensorPath && nextProps.sensorPath !== this.sensorPath) {
        //         this.sensorPath = nextProps.sensorPath;
        //     }
        // }

        // componentWillUpdate(nextProps, nextState) {
        //     if (nextState.sensorPath !== this.sensorPath && !this.sensorSub) {
        //         if (this.context.p.isAuthenticated()) {
        //             // Can't run this in this tick, as we set state
        //             this.onAuthenticated();
        //         } else {
        //             this.context.p.addListener("authenticated", this.onAuthenticated);
        //         }
        //     }
        // }

        onAuthenticated = () => {
            const { t, p } = this.props;
            if (this.sensorSub) {
                p.unsubscribeDS(this.updateSensorInDS, this.sensorSub);
            }
            this.sensorSub = p.subscribeDS(this.sensorPath, this.updateSensorInDS);
            this.updateSensorInDS(p.getPath(this.sensorPath));
        }

        componentWillUnmount () {
            const { t, p } = this.props;
            if (this.sensorSub) {
                p.unsubscribeDS(this.updateSensorInDS, this.sensorSub);
            }
            if (this.state.connectionSub) {
                p.unsubscribeDS(this.updateConnectionInDS, this.state.connectionSub);
            }
        }

        updateConnectionInDS = (value) => {
            if (value && value.state) {
                this.setState({connection: value});
            }
        }

        updateSensorInDS = (value) => {
            const { t, p } = this.props;
            // As soon as we get this, we need to subscribe to the right connection in DS so
            // we have both sensor state and connection state
            if (value && value.state) {
                this.setState({sensor: value});
                
                const connectionKey = "connections/" + value.url.replace(/\//g, "%2F");
                if (connectionKey !== this.connectionPath) {
                    if (this.connectionSub) {
                        p.unsubscribeDS(this.updateConnectionInDS, this.connectionSub);
                    }
                    this.connectionSub =  p.subscribeDS(connectionKey, this.updateConnectionInDS)
                    this.connectionPath = connectionKey;
                    this.setState({
                        connection: p.getPath(connectionKey)
                    });
                }
            }
        }

        setSensorPath = (newPath) => {
            if (newPath !== this.sensorPath) {
                this.sensorPath = newPath;
                if (this.props.p.isAuthenticated()) {
                    // Can't run this in this tick, as we set state
                    this.onAuthenticated();
                } else {
                    this.props.p.addListener("authenticated", this.onAuthenticated);
                }
            }
        }

        render() {
            
            return <Component key={this.props.sensorPath} setSensorPath={this.setSensorPath} {...this.props} {...this.state} />;
        }
    };
};
